var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"screenshotsPosition",staticClass:"theme-bg screenshots",attrs:{"id":"screenshots"}},[_vm._m(0),_c('div',{staticClass:"container"},[_vm._m(1),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"swiper-screenshots-container-1 swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},[_c('swiper',{attrs:{"modules":_vm.modules,"slides-per-view":3,"space-between":0,"centeredSlides":true,"navigation":true,"loop":true,"breakpoints":{
                '100': {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
                '360': {
                  slidesPerView: 3,
                  spaceBetween: 0,
                },
                '640': {
                  slidesPerView: 5,
                  spaceBetween: 0,
                },
              }}},_vm._l((_vm.images),function(image){return _c('swiper-slide',{key:image.id},[_c('div',[_c('img',{attrs:{"src":image.imageUrl,"alt":"1"}})])])}),1)],1)])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animation-circle"},[_c('i'),_c('i'),_c('i')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"section-title"},[_c('h2',{staticClass:"text-white"},[_vm._v("Chat Loop Screen Shot")]),_c('img',{staticClass:"img-fluid",attrs:{"src":require("../../assets/images/white-line.png"),"alt":"title-line"}})])])])
}]

export { render, staticRenderFns }